import React from 'react';
import AddBillingFunctional from './components/add-billing-functional';
import './styles.scss';

const AddBilling = ({ state, setState, refreshList, editData }) => {
	return <AddBillingFunctional {...{ state, setState, refreshList, editData }} />;
};

export default AddBilling;
